import axios from "axios";
const baseUrl = "https://o11epex4s2.execute-api.ap-south-1.amazonaws.com/dev";
const guestWebsiteUrl = "https://hrms.invensis.net";
const compilerURL = "https://piston.krtrimaiq.ai";

// serverAPI.js
export const login = async (payload) => {
  try {
    let config = {};
    let body = {};

    if (payload?.Authorization) {
      // Token-based login: send only headers, no body
      config.headers = {
        Authorization: payload.Authorization,
      };
      body = {}; // Empty body
    } else {
      // SSO login: send full payload in body
      body = payload;
    }

    const response = await axios.post(`${baseUrl}/login`, body, config);
    return response;
  } catch (error) {
    console.log("Login error:", error);
    throw error;
  }
};

export const getCourses = (
  email,
  roleId,
  organizationId,
  department,
  userId,
) => {
  return axios.get(
    `${baseUrl}/get-courses?email=` +
    email +
    `&roleId=` +
    roleId +
    `&organizationId=` +
    organizationId +
    `&department=` +
    department +
    `&userId=` +
    userId,
  );
};

export const getUsers = (email, roleId, organizationId) => {
  return axios.get(
    `${baseUrl}/get-users?email=` +
    email +
    `&roleId=` +
    roleId +
    `&organizationId=` +
    organizationId,
  );
};

// TODO: no api in the backend
export const getOrganizations = (email, roleId) => {
  return axios.get(
    `${baseUrl}/get-organizations?email=` + email + `&roleId=` + roleId,
  );
};

export const createSingleOrganization = (body) => {
  return axios.post(`${baseUrl}/create-organization`, body, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getFeatures = (userRole) => {
  const headers = {
    "Content-Type": "application/json",
  };
  return axios.get(`${baseUrl}/get-features?userRole=${userRole}`, {
    headers: headers,
  });
};

export const createUser = (body) => {
  return axios.post(`${baseUrl}/create-user`, body);
};

// TODO: no api in the backend
export const createOrganization = (body) => {
  return axios.post(`${baseUrl}/create-organizations`, body);
};

export const getSignedUrl = (body) => {
  return axios.post(`${baseUrl}/get-signed-url`, body);
};

export const getCourseDetails = (courseId, userId) => {
  return axios.get(
    `${baseUrl}/view-course?courseId=${courseId}&userId=${userId}`,
  );
};

export const assignOperation = (body) => {
  return axios.post(`${baseUrl}/assign-operation`, body);
};

export const quizSubmit = (body) => {
  return axios.post(`${baseUrl}/submit-assessment`, body);
};

export const configOrganizationSubmit = (body) => {
  return axios.post(`${baseUrl}/configure-organization`, body);
};

export const getConfigOrganization = async (email, organizationId, userId) => {
  try {
    return await axios.get(
      `${baseUrl}/get-organization-config?email=${email}&organizationId=${organizationId}&userId=${userId}`,
    );
  } catch (error) {
    return error;
  }
};

export const fetchOrganizationDetails = async (organizationId) => {
  try {
    return await axios.get(
      `${baseUrl}/get-organization-details?organizationId=${organizationId}`,
    );
  } catch (error) {
    return error;
  }
};

export const submitComment = (body) => {
  return axios.post(`${baseUrl}/add-discussion-forum`, body);
};

export const getUserGroups = (email, organizationId, userId) => {
  return axios.get(
    `${baseUrl}/get-user-groups?email=` +
    email +
    `&organizationId=` +
    organizationId +
    `&userId=` +
    userId,
  );
};

export const createUserGroup = (body) => {
  return axios.post(`${baseUrl}/create-user-group`, body);
};

export const getSingleUserGroup = (email, userGroupId, userId) => {
  return axios.get(
    `${baseUrl}/get-single-user-group?email=` +
    email +
    `&userGroupId=` +
    userGroupId +
    `&userId=` +
    userId,
  );
};

export const modifyUserGroup = (body) => {
  return axios.post(`${baseUrl}/modify-user-group`, body);
};

export const updateUserPorgress = (body) => {
  // return axios.post(`${baseUrl}/update-user-progress`, body);
  return body;
};

export const bulkUserUpload = (body) => {
  try {
    return axios.post(`${baseUrl}/bulk-user-upload`, body);
  } catch (error) {
    return error;
  }
};

export const fetchNotification = (email, userId) => {
  try {
    return axios.get(
      `${baseUrl}/get-notifications?email=${email}&userId=${userId}`,
    );
  } catch (error) {
    return error;
  }
};

export const getAssessment = (email, userId) => {
  return axios.get(
    `${baseUrl}/view-assessment-results?email=${email}&userId=${userId}`,
  );
};

export const dashboardMetrics = async (
  email,
  roleId,
  organizationId,
  department,
) => {
  try {
    return await axios.get(
      `${baseUrl}/get-dashboard-metrics?email=${email}&roleId=${roleId}&organizationId=${organizationId}&department=${department}`,
    );
  } catch (error) {
    return error;
  }
};

export const createCourseDetails = (body) => {
  try {
    return axios.post(`${baseUrl}/create-course`, body);
  } catch (error) {
    return error;
  }
};

export const vectorizeContent = (body) => {
  try {
    // return axios.post(`${baseUrl}/generate-questions`, body);
    return axios.post(
      `https://qna-generator.lms.krtrimaiq.ai/vectorize-content`,
      body,
    );
  } catch (error) {
    return error;
  }
};

export const generateQuestions = (body) => {
  try {
    // return axios.post(`${baseUrl}/generate-questions`, body);
    return axios.post(
      `https://qna-generator.lms.krtrimaiq.ai/generate-questions`,
      body,
    );
  } catch (error) {
    return error;
  }
};

export const deleteContent = () => {
  try {
    return axios.get(`https://qna-generator.lms.krtrimaiq.ai/delete-content`);
  } catch (error) {
    return error;
  }
};
//Hard Coded for python
// const latestVersions = {
//   python: "3.12.0",
//   javascript: "latest",
//   java: "17",
//   csharp: "latest",
//   cpp: "latest",
// };

// export const executeCode = async (language, files, userInput) => {
//   try {
//     const version = latestVersions[language.toLowerCase()] || "latest";

//     const response = await axios.post(`${baseUrl}/code-compiler`, {
//       language: "python",
//       version: "3.12.0",
//       files,
//       stdin: userInput,
//     });

//     return response.data;
//   } catch (error) {
//     console.error("Error executing code:", error);
//     throw error;
//   }
// };

export const executeCode = async (payload) => {
  try {
    // Destructure the necessary properties from the payload
    const { language, files, stdin, version } = payload;

    const response = await axios.post(`${compilerURL}/api/v2/execute`, {
      language: language.toLowerCase(),
      version,
      files,
      stdin,
    });

    return response.data;
  } catch (error) {
    console.error("Error executing code:", error);
    // Re-throw the error so the caller can handle it.
    throw error;
  }
};

export const codeReview = async (payload) => {
  try {
    const response = await axios.post(
      `${compilerURL}/qa/content-generation/code-review`,
      payload,
      {
        responseType: "arraybuffer", // keep as PDF binary
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error during code review:", error);
    throw error;
  }
};

export const dbEngine = async ({ userId, query, action, schema }) => {
  try {
    let response;

    switch (action) {
      // Start a session
      case "start":
        response = await axios.post(
          `${compilerURL}/db-engine/session/start`,
          {
            user_id: userId,
            schema_sql: schema, // Pass the schema variable here
          },
          { headers: { "Content-Type": "application/json" } },
        );
        break;

      // Execute a query
      case "query":
        if (!query) throw { message: "Query is required for 'query' action" };
        response = await axios.post(
          `${compilerURL}/db-engine/query/execute`,
          { session_id: userId, query },
          { headers: { "Content-Type": "application/json" } },
        );
        break;

      // End a session
      case "end":
        response = await axios.delete(
          `${compilerURL}/db-engine/session/end/${userId}`,
          { headers: { "Content-Type": "application/json" } },
        );
        break;

      // Fetch tables
      case "fetch_tables":
        response = await axios.get(`${compilerURL}/db-engine/tables/${userId}`);
        break;

      default:
        throw { message: "Invalid action provided" };
    }

    console.log("Response from dbEngine:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in dbEngine:", error.response?.data || error.message);
    throw (
      error.response?.data || {
        message: "Failed to connect to dbEngine",
        details: error.message,
      }
    );
  }
};

export const sendChatMessage = async (context, userId) => {
  const response = await fetch(
    `${compilerURL}/qa/content-generation/ai-assist`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type: "chat",
        message: context,
        user_id: userId,
      }),
    },
  );

  if (!response.ok) {
    throw new Error("Failed to send chat message.");
  }

  return response.json();
};

export const codeSolutionGenerator = async (payload, userId) => {
  try {
    const response = await axios.post(
      `${compilerURL}/qa/content-generation/ai-assist`,
      {
        type: "solution",
        user_id: userId,
        language: payload.language,
        version: payload.version,
        problem_statement: payload.problem_statement,
        request_mode: payload.request_mode || "solution",
        bloom_level: payload.bloom_level,
        test_cases: payload.test_cases || null,
        file_url: payload.file_url || null,
      },
      {
        signal: payload.signal,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in codeSolutionGenerator:", error);
    throw error;
  }
};

export const fetchCompletionsFromBackend = async (
  code,
  language,
  problemStatement,
  testCases,
  sessionId, // New parameter for session ID
) => {
  const response = await fetch(
    `${compilerURL}/qa/content-generation/ai-assist`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type: "inline-completion",
        code_snippet: code,
        language,
        problem_statement: problemStatement,
        test_cases: testCases,
        session_id: sessionId, // Send the session ID
      }),
    },
  );

  if (!response.ok) {
    throw new Error("Failed to fetch code completions.");
  }

  return response.json();
};

export const vectorGenerator = async (
  file,
  organizationId,
  sectionId = null,
) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("organization_id", organizationId);

    // Only append section_id if provided
    if (sectionId) {
      formData.append("section_id", sectionId);
    }

    const response = await fetch(
      `${compilerURL}/vectorisation-rag/upload-file`,
      {
        method: "POST",
        body: formData, // Let browser set Content-Type + boundary
      },
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Vectorization failed: ${response.status} - ${errorText}`,
      );
    }

    return await response.json();
  } catch (error) {
    console.error("Error in vectorGenerator:", error);
    throw error;
  }
};

export const deleteFileVectors = async (
  organizationId,
  fileName,
  sectionId = null,
) => {
  const formData = new FormData();
  formData.append("organization_id", organizationId);
  formData.append("file_name", fileName);
  if (sectionId) formData.append("section_id", sectionId.trim());

  const response = await fetch(`${compilerURL}/vectorisation-rag/delete-file`, {
    method: "DELETE",
    body: formData,
  });

  if (!response.ok) throw new Error("Delete failed");
  return response.json();
};

export const trackVideoProgress = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/track-video-progress`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateDocumentProgress = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/update-document-progress`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateCodeSandboxProgress = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/update-code-sandbox-progress`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const contentDetails = async (payload) => {
  try {
    const response = await axios.get(
      `${baseUrl}/content-details?contentId=${payload?.contentId}&contentType="video"`,
    );
    return response.data;
  } catch (error) {
    console.error("Error executing code:", error);
    throw error;
  }
};

export const editUser = async (userData) => {
  try {
    const response = await axios.post(`${baseUrl}/modify-user`, userData);
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchFinalAssessments = async (userId) => {
  try {
    const response = await axios.get(
      `${baseUrl}/assessment-results?userId=${userId}`,
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchCordinatorMatric = async (userId) => {
  try {
    const response = await axios.get(
      `${baseUrl}/coordinator-metrics?userId=${userId}`,
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchTrainingProgramProgress = async (userId) => {
  try {
    const response = await axios.get(
      `${baseUrl}/training-program-progress?userId=${userId}`,
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchIndividualTrainingProgram = async (
  userId,
  groupId,
  courseId,
) => {
  try {
    if (courseId) {
      const response = await axios.get(
        `${baseUrl}/individual-training-program?userId=${userId}&groupId=${groupId}&courseId=${courseId}`,
      );
      return response;
    } else {
      const response = await axios.get(
        `${baseUrl}/individual-training-program?userId=${userId}&groupId=${groupId}`,
      );
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const quizBulkUpload = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/qa-extraction`, payload);
    return response;
  } catch (error) {
    return error;
  }
};

export const createLiveClass = async (token, payload) => {
  try {
    const response = await axios.post(`${baseUrl}/add-live-class`, payload);
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchLiveClasses = async (token, payload) => {
  try {
    const response = await axios.post(`${baseUrl}/fetch-live-classes`, payload);
    return response;
  } catch (error) {
    return error;
  }
};
export const fetchLiveClassesForUser = async (token, payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/fetch-live-classes-for-user`,
      payload,
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const checkUserPartOfThisLiveClass = async (token, payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/check-live-class-user`,
      payload,
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getLivekitToken = async (token, payload) => {
  try {
    const response = await axios.post(`${baseUrl}/get-token`, payload);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateDetailsLiveClassAPI = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/update-liveClass`, payload);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteLiveClassAPI = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/delete-live-class`, payload);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateOrganizationInfo = async (token, payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/modify-organization`,
      payload,
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getDraftCourses = async (
  email,
  roleId,
  organizationId,
  userId,
) => {
  try {
    const response = await axios.get(
      `${baseUrl}/get-saved-courses?email=${email}&roleId=${roleId}&organizationId=${organizationId}&userId=${userId}`,
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteCourseContent = (body) => {
  try {
    return axios.post(`${baseUrl}/create-course`, body);
  } catch (error) {
    return error;
  }
};

export const deleteCourseSection = (body) => {
  try {
    return axios.post(`${baseUrl}/create-course`, body);
  } catch (error) {
    return error;
  }
};

export const publishTheCourse = (body) => {
  try {
    return axios.post(`${baseUrl}/publish-course`, body);
  } catch (error) {
    return error;
  }
};

export const updateUserPassword = (payload) => {
  try {
    return axios.post(`${baseUrl}/update-password`, payload);
  } catch (error) {
    return error;
  }
};

export const generateContentAPI = () => {
  return `${compilerURL}/qa/content-generation/ws/chat`;
};

export const regenerateContentAPI = (body) => {
  try {
    return axios.post(
      `${compilerURL}/qa/content-generation/api/regenerate`,
      body,
    );
  } catch (error) {
    return error;
  }
};

// Save generated content
export const saveGeneratedContentAPI = (body) => {
  try {
    return axios.post(`${baseUrl}/save-generated-content`, body);
  } catch (error) {
    return error;
  }
};

// Get all generated contents
export const getGeneratedContentsAPI = (userId) => {
  try {
    return axios.get(`${baseUrl}/get-generated-contents?userId=${userId}`);
  } catch (error) {
    return error;
  }
};

// Get a single generated content
export const fetchGeneratedContentAPI = (body) => {
  try {
    return axios.post(`${baseUrl}/fetch-generated-content`, body);
  } catch (error) {
    return error;
  }
};

// Get all generated Videos
export const getGeneratedVideosAPI = (userId) => {
  try {
    return axios.get(`${baseUrl}/get-generated-videos?userId=${userId}`);
  } catch (error) {
    return error;
  }
};

//Get all generated PPTs
export const getGeneratedPPTsAPI = (userId) => {
  try {
    return axios.get(`${baseUrl}/fetch-ppt?userId=${userId}`);
  } catch (error) {
    return error;
  }
};

//Get all uploaded Resources
export const getUploadedResorucesAPI = (userId) => {
  try {
    return axios.get(`${baseUrl}/fetch-uploaded-resources?userId=${userId}`);
  } catch (error) {
    return error;
  }
};

//Get all generated qnas
export const getGeneratedQAsAPI = (userId) => {
  try {
    return axios.get(`${baseUrl}/fetch-generated-qna?userId=${userId}`);
  } catch (error) {
    return error;
  }
};

// Generate new Video
export const generateVideoAPI = (payload) => {
  try {
    return axios.post(
      `${compilerURL}/qa/content-generation/generate-video`,
      payload,
    );
  } catch (error) {
    return error;
  }
};

//Generate new PPT
export const generatePPTAPI = (payload) => {
  try {
    return axios.post(
      `${compilerURL}/qa/content-generation/generate-ppt`,
      payload,
    );
  } catch (error) {
    return error;
  }
};

// New Guest Website APIs
export const guestLoginAPI = async (token) => {
  try {
    const response = await axios.get(`${guestWebsiteUrl}/api/employee/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getEmployeeByIdAPI = async (employeeId, token) => {
  try {
    const response = await axios.get(
      `${guestWebsiteUrl}/api/employeebyid/${employeeId}/`,
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const fetchNewUsersAPI = async (date, token) => {
  try {
    const response = await axios.get(
      `${guestWebsiteUrl}/api/employees/?doj=${date}`,
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

// fetch user management
export const fetchUserManagementAPI = (params) => {
  try {
    return axios.get(`${baseUrl}/get-user-management`, { params });
  } catch (error) {
    return error;
  }
};

// Participation & performance (table data, quiz/code progress)
export const fetchParticipationPerformance = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/participant-performance`,
      payload,
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const DownloadPDFAPI = (body) => {
  try {
    return axios.post(
      `${compilerURL}/qa/content-generation/generate-pdf`,
      body,
      {
        headers: { "Content-Type": "application/json" },
        responseType: "blob",
      },
    );
  } catch (error) {
    return error;
  }
};

// Get all vectorised Resources
export const getvectorisedResourcesAPI = (userId, sectionId = null) => {
  try {
    let url = `${baseUrl}/fetch-vectorised-resources?userId=${userId}`;

    // Add sectionId to URL if provided
    if (sectionId) {
      url += `&sectionId=${sectionId}`;
    }

    return axios.get(url);
  } catch (error) {
    return error;
  }
};

//Genereate QnA from RAG
export const generateQNAAPI = (payload, sectionId) => {
  try {
    let url = `${compilerURL}/qa/content-generation/generate-qa`;

    // Append sectionId if provided
    if (sectionId) {
      url += `?sectionId=${sectionId}`;
    }

    return axios.post(url, payload); // POST with body
  } catch (error) {
    console.error("Q&A Generation failed:", error);
    throw error;
  }
};

export const generateQnaPDF = (payload) => {
  const url = `${compilerURL}/qa/content-generation/generate-qna-pdf`;
  return axios.post(url, payload, {
    headers: { "Content-Type": "application/json" },
  });
};

// Document image upload (method: PUT) or delete (method: DELETE)
export const documentImageAPI = (payload) => {
  return axios.post(
    `${compilerURL}/qa/content-generation/document-images`,
    payload,
    { headers: { "Content-Type": "application/json" } }
  );
};

export const generateAccaQAAPI = (payload) => {
  const url = `${compilerURL}/qa/acca-training/generate-acca-qa`;
  return axios.post(url, payload, {
    headers: { "Content-Type": "application/json" },
  });
};

export const generateAccaPDFAPI = (payload) => {
  const url = `${compilerURL}/qa/acca-training/generate-pdf?binary=false`;
  return axios.post(url, payload, {
    headers: { "Content-Type": "application/json" },
  });
};

// 1. HTTP POST → initialize session
export const initializeChatSessionAPI = (body) => {
  return axios.post(
    `${compilerURL}/qa/content-generation/initialize-content-chat`, // ← FIXED
    body,
  );
};

// 2. WebSocket → streaming
export const getBaseWebSocketUrl = () => {
  return (
    compilerURL.replace(/^https/, "wss") +
    "/qa/content-generation/initialize-content-chat"
  );
};

export const sakhaChatbotUrl = () => {
  return (
    compilerURL.replace(/^https/, "wss") +
    "/qa/acca-training/student-chatbot/ws"
  );
};

// Local Testing
// export const sakhaChatbotUrl = () => {
//   return "ws://localhost:6426/acca-training/student-chatbot/ws";
// };
export const notesExtractor = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(`${compilerURL}/extraction/extract-text`, {
      method: "POST",
      body: formData, // browser sets Content-Type + boundary automatically
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Notes extraction failed: ${response.status} - ${errorText}`,
      );
    }

    // Parse and return JSON response (e.g. extracted text)
    return await response.json();
  } catch (error) {
    console.error("Error in notesExtractor:", error);
    throw error;
  }
};

export const evaluateAnswer = async (payload) => {
  try {
    return axios.post(
      `${compilerURL}/qa/content-generation/subjective-ans-evaluate`,
      payload
      ,
    );
  } catch (error) {
    console.error("Error evaluating answer:", error);
    throw error;
  }
};

// navigator.sendBeacon can't reuse the axios call above — it must fire synchronously
// during page unload/refresh — but the endpoint stays owned by this module either way.
export const sendEvaluateAnswerBeacon = (payload) => {
  return navigator.sendBeacon?.(
    `${compilerURL}/qa/content-generation/subjective-ans-evaluate`,
    new Blob([JSON.stringify(payload)], { type: "application/json" }),
  );
};

export const saveTeacherReviewedSubjectiveQuizResults = async (payload) => {
  try {
    return axios.post(`${baseUrl}/save-subjective-ans-evalution`, payload);
  } catch (error) {
    console.error("Error saving answer:", error);
    throw error;
  }
};

export const fetchAcademicyears = async (payload) => {
  try {
    const response = await axios.get(`${baseUrl}/get-academic-years`, {
      params: payload,
    });
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to fetch academic years";
  }
};

export const createAcademicYear = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/create-academic-year`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to create academic year";
  }
};

export const deleteAcademicYear = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/manage-academic-year`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to delete academic year";
  }
};

export const updateAcademicYear = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/manage-academic-year`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to update academic year";
  }
};

export const fetchEventTypes = async (payload) => {
  try {
    const response = await axios.get(`${baseUrl}/get-event-types`, {
      params: payload,
    });
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to fetch Event Types";
  }
};

export const createEventType = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/create-event-type`, payload);
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to create Event Type";
  }
};

export const deleteEventType = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/manage-event-type`, payload);
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Delete Event Type";
  }
};

export const updateEventType = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/manage-event-type`, payload);
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Update Event Type";
  }
};

export const fetchClassSections = async (payload) => {
  try {
    const response = await axios.get(`${baseUrl}/get-class-sections`, {
      params: payload,
    });
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to fetch Class Sections";
  }
};

export const createClassSection = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/create-class-section`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Create Class Section";
  }
};

export const deleteClassSection = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/manage-class-section`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Delete Class Section";
  }
};

export const updateClassSection = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/manage-class-section`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Update Class Section";
  }
};

export const createEvent = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/create-event`, payload);
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Create Event";
  }
};

export const fetchEvents = async (payload) => {
  try {
    const response = await axios.get(`${baseUrl}/get-events`, {
      params: payload,
    });
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Fetch Events";
  }
};

export const updateEvent = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/manage-event`, payload);
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Update Event";
  }
};

export const deleteEvent = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/manage-event`, payload);
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Update Event";
  }
};

export const fetchTimeTableTemplates = async (payload) => {
  try {
    const response = await axios.get(`${baseUrl}/fetch-time-table`, {
      params: payload,
    });
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Fetch Time Table Templates";
  }
};

export const createTimeTableTemplate = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/create-timetable`, payload);
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Create Time Table Template";
  }
};

export const deleteTimeTableTemplate = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/delete-time-table`, payload);
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Delete Time Table Template";
  }
};

export const updateTimeTableTemplate = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/update-timetable`, payload);
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Update Time Table Template";
  }
};

export const fetchTimeTableEntries = async (payload) => {
  try {
    const response = await axios.get(`${baseUrl}/fetch-time-table-entries`, {
      params: payload,
    });
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Fetch Time Table";
  }
};

export const createTimeTableEntry = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/create-timeTable-entries`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Create Time Table Entry";
  }
};

export const updateTimeTableEntry = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/update-timeTable-entries`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Update Time Table Entry";
  }
};

export const deleteTimeTableEntry = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/delete-timeTable-entries`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Delete Time Table Entry";
  }
};

export const markAttendance = async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}/attendance`, payload);
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to Save Attendance";
  }
};

export const fetchAttendanceHistory = async (payload) => {
  try {
    const response = await axios.get(`${baseUrl}/attendance-history`, {
      params: payload,
    });
    return response.data;
  } catch (error) {
    return error.response?.data || "Failed to fetch Attendance History";
  }
};
